export default {
    "helloVisitor": "Hello, Visitor",
    "hello": "Hello, {name}",
    "points": "points",
    "loginButton": "Log in",
    "rewardsTitle": "Rewards",
    "rewardsSubtitle": "Exchange your points for rewards",
    "rewardsEmpty": "No rewards available right now.",
    "activeCoupons": "Active coupons",
    "couponAvailable": "Available",
    "couponValidUntil": "Valid until {date}",
    "copyCode": "Copy code",
    "codeCopied": "Code copied!",
    "rewardUnavailable": "Unavailable",
    "rewardPoints": "{points} points",
    "rewardRedeemed": "Redeemed",
    "rewardExclusive": "Reward exclusive to members",
    "rewardTierExclusiveOne": "Exclusive to customers of the tier",
    "rewardTierExclusiveMany": "Exclusive to customers of the tiers",
    "missingPoints": "{points} points to go",
    "missingOnePoint": "1 point to go",
    "useNow": "Use now",
    "redeemTitle": "Exchange {points} points for \"{name}\"?",
    "redeemMessage": "This will reduce your balance by {points} points.",
    "redeemConfirm": "Confirm",
    "redeemCancel": "Cancel",
    "redeemClose": "Close",
    "redeemSuccessTitle": "Reward redeemed!",
    "redeemSuccessMessage": "Reward redeemed successfully. Check with the business to use it.",
    "redeemSuccessHome": "Home screen",
    "redeemError": "We couldn't redeem it right now, please try again.",
    "redeemErrorPointsProgramInactive": "The points program is not available right now.",
    "redeemErrorStaffOnly": "This reward can only be redeemed at the business.",
    "redeemErrorRewardUnavailable": "This reward is no longer available.",
    "redeemErrorRecentRedemption": "You just redeemed this reward, wait 1 minute and try again.",
    "redeemErrorInsufficientPoints": "You don't have enough points.",
    "yourPoints": "Your points:",
    "loginToSeePoints": "Log in to see your points",
    "howToUse": "How do I use this reward?",
    "back": "Back",
    "redeemReward": "Redeem reward",
    "insufficientPoints": "Not enough points",
    "redeemTierLocked": "Exclusive to another tier",
    "loginToRedeem": "Log in to redeem",
    "confirmRedeemTitle": "Redeem this reward?",
    "redeemStaffTitle": "How to redeem",
    "balanceAfter": "Your balance after the exchange:",
    "faqTitle": "Frequently Asked Questions",
    "faqOthers": "Other Questions",
    "faqSearch": "Search",
    "faqEmpty": "No questions have been added yet.",
    "faqNoResults": "No questions match your search.",
    "bannerSlide": "Banner {index} of {total}",
    "modalClose": "Close",
    "termsTitle": "Terms of use",
    "termsAccept": "I have read and agree to the terms of use",
    "termsEmpty": "No terms of use have been published yet.",
    "statementTitle": "Statement",
    "statementBalance": "Points balance:",
    "statementEmpty": "No activity here yet.",
    "statementDateLine": "{date} at {time} - {weekday}",
    "statementReceived": "Earned {points} points!",
    "statementReceivedOne": "Earned 1 point!",
    "statementUsed": "Spent {points} points!",
    "statementUsedOne": "Spent 1 point!",
    "statementReward": "Reward: {name}",
    "statementPurchase": "Purchase made {date}",
    "statementAddedBy": "Points added by: {name}",
    "statementAdded": "Points added",
    "statementExpand": "Expand statement",
    "statementCollapse": "Collapse statement",
    "menuStatement": "Statement",
    "menuFaq": "Frequently asked questions",
    "menuTerms": "Terms of use",
    "menuTiers": "Tier rules",
    "menuYourTier": "Your tier",
    "menuOtherTiers": "Other tiers",
    "menuTiersGroup": "Tiers",
    "tiersMember": "You are part of this tier",
    "tiersBecome": "How to become {name}?",
    "tiersExclusiveRewards": "Exclusive rewards",
    "tiersNoExclusiveRewards": "No exclusive rewards in this tier.",
    "menuRules": "Rules",
    "rulesTitle": "Program rules",
    "menuLogout": "Log out",
    "tabPoints": "Points",
    "tabCashback": "Cashback",
    "tabReferral": "Referral",
    "comingSoon": "Coming soon"
};
